import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { SetupService } from '../configuracoes/setup/setup.service';
import { UsuarioLogado } from '../seguranca/usuario/usuario-logado.model';
import { UsuarioService } from '../seguranca/usuario/usuario.service';
import { AuthService } from '../shared/auth/auth.service';
import { GlobalsVariablesService } from '../shared/service/global-variables.service';
import { MessageService } from '../shared/service/message.service';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: [
        './login.css',
        './login.responsive.css'
    ]
})
export class LoginComponent {

    public loginModel: any = {};
    public statusLogin: boolean = true;
    private usuarioLogado: UsuarioLogado = new UsuarioLogado();
    public authToken;
    public errors;

    constructor(
        public _router: Router,
        public _messageService: MessageService,
        public _authService: AuthService,
        public _usuarioService: UsuarioService,
        public globalsVariablesService: GlobalsVariablesService,
        public cookieService: CookieService,
        public _setupService: SetupService
    ) {
        document.querySelector('body').classList.add('backLogin');
    }



    private logar() {
        this._authService.authenticate(this.loginModel).subscribe(res => {
            this.authToken = res.mensagem;
            document.querySelector('body').classList.remove('backLogin');

            this._authService.autenticarUsuario(this.loginModel).subscribe(res => {
                this.usuarioLogado = res;
                if (this.usuarioLogado.pessoaNomeFantasia != '' && this.usuarioLogado.pessoaNomeFantasia != 'undefined') {
                    this._setupService.getSetup().then(setup => {

                        this.globalsVariablesService.setGlobalsVariables(this.usuarioLogado);
                        this.globalsVariablesService.setInformacoesSetup(setup);
                        this.cookieService.set('user', JSON.stringify(this.loginModel), 365);
                        //this._router.navigate(['/dashboard']);
                        this.navegarPedido();
                        localStorage.setItem("primeiroAcesso", "true");
                    }).catch(err => {
                        console.log("Falha ao carregar o SETUP: ", err);
                        this.globalsVariablesService.setGlobalsVariables(this.usuarioLogado);
                        this.cookieService.set('user', JSON.stringify(this.loginModel), 365);
                        this.navegarPedido();
                        //this._router.navigate(['/dashboard']);
                    });
                }
            },
                err => {
                    this._messageService.error('Usuário ou senha incorretos. Por favor tente novamente.');
            });

        }, error => {
            this.errors = error;
            this._messageService.error('Usuário ou senha incorretos. Por favor tente novamente.');
        });

    }

    removerCaracteresEspeciais(loginInput: HTMLInputElement) {
        console.log(loginInput.value);
        loginInput.value = loginInput.value.replace(".", "").replace("/", "").replace("-", "").replace(".", "");
        this.loginModel.login = loginInput.value;
    }

    navegarPedido(): void{
        this._router.navigate(['/comercial/pedido/new']);
    }
}